import { useCallback, useSyncExternalStore } from "react";

function getPathname() {
	return window.location.pathname;
}

function subscribe(callback: () => void) {
	window.addEventListener("popstate", callback);
	return () => window.removeEventListener("popstate", callback);
}

export function useRouter() {
	const pathname = useSyncExternalStore(subscribe, getPathname, getPathname);

	const navigate = useCallback((path: string) => {
		window.history.pushState(null, "", path);
		window.dispatchEvent(new PopStateEvent("popstate"));
	}, []);

	return { pathname, navigate };
}
